import EntityPage from "@/components/EntityPage";
import { GRID_STATUS, SUBMIT_STATUS } from "@/lib/status";

// 'Terupload' satu arah: hanya ditawarkan kalau nilainya sekarang 'Disetujui' atau 'Terupload'.
// Ditegakkan di UI saja (backend menerima nilainya, tapi tidak ada jalur lain yang mengubahnya).
const opsiTerupload = (row, key) =>
  row?.[key] === "Disetujui" || row?.[key] === "Terupload" ? GRID_STATUS : GRID_STATUS.filter((s) => s !== "Terupload");

const COLUMNS = [
  { key: "grid_id", label: "Grid ID", type: "text" },
  { key: "status_2d", label: "Status Digitasi 2D", type: "status", options: GRID_STATUS, optionsFor: (row) => opsiTerupload(row, "status_2d") },
  { key: "tgl_submit_2d", label: "Tanggal Submit 2D", type: "date" },
  { key: "tgl_supervisi_2d", label: "Tanggal Supervisi 2D", type: "date" },
  { key: "status_3d", label: "Status Pemodelan 3D", type: "status", options: GRID_STATUS, optionsFor: (row) => opsiTerupload(row, "status_3d") },
  { key: "tgl_submit_3d", label: "Tanggal Submit 3D", type: "date" },
  { key: "tgl_supervisi_3d", label: "Tanggal Supervisi 3D", type: "date" },
  { key: "status_submit_foto", label: "Submission Foto", type: "status", options: SUBMIT_STATUS },
  { key: "status_submit_lidar", label: "Submission Lidar", type: "status", options: SUBMIT_STATUS },
];

export default function GridsPage() {
  return <EntityPage title="Grid Peta" eyebrow="Modul 02 · Tabular Grid" endpoint="/grids" prefix="grid" columns={COLUMNS} filterKey="status_2d" layerKey="grid-peta" canCreate={false} canDelete={false} />;
}
